import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout/Layout";
import TopTabs from "./Components/TopTabs";
import TopBanner from "./Components/TopBanner";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getActivityList, getCateoryList, getEventByName } from "../../../redux/actions/event";

const QuizProgramDetail = () => {

  const location = useLocation();
  const dispatch = useDispatch();

  const eventCode = location.state?.eventCode;

  const eventDetails = useSelector(state => state.event.eventDetails);
  const activityList = useSelector(state => state.event.activityList);

  const ageRange = eventDetails?.filter?.filter_type === "Age" ? eventDetails?.filter?.filter_range : [];
  const classRange = eventDetails?.filter?.filter_type === "Class" ? eventDetails?.filter?.filter_range : [];
  const initAge = ageRange?.length ? `${ageRange?.[0]?.minimum}-${ageRange?.[0]?.maximum}` : null;
  const initClass = classRange?.length ? `${classRange?.[0]?.minimum}-${classRange?.[0]?.maximum}` : null;

  const [categoryId, setCategoryId] = useState();

  useEffect(() => {
    dispatch(getEventByName({ eventCode }, (data) => {
      const { event_id, min_age, max_age } = data
      dispatch(getCateoryList({ competition_id: event_id, page_number: 0, page_size: 100 }, (category_id) => {
        setCategoryId(category_id);
        // dispatch(getActivityList({ category_id, competition_id: event_id, min_age: 6, max_age: 6 }))
      }))
    }));
  }, [])

  return (
    <Layout page="learningPrograms" title="Learning Programs">
      <TopBanner data={eventDetails} />
      {categoryId &&
        <TopTabs
          categoryId={categoryId}
          eventDetails={eventDetails}
          data={activityList}
          ageGrp={initAge}
          classGrp={initClass}
          ageRange={ageRange}
          classRange={classRange}
        />
      }
    </Layout>
  );
};

export default QuizProgramDetail;
